import { PRODUCT_BASE_PATHS } from '@cast/console-constants';

import { DboRoute } from '../routes';

const STORAGE_KEY_PREFIX = 'dbo-sidebar-params';

export const getDboSidebarParamsStorageKey = (organizationId: string) =>
  `${STORAGE_KEY_PREFIX}-${organizationId}`;

export type DboSidebarParams = {
  dbServerId?: string;
  databaseId?: string;
};

export const dboServerRoutePattern = `${PRODUCT_BASE_PATHS.dbo}/${DboRoute.SERVER_ROOT}/*`;
export const dboDatabaseRoutePattern = `${PRODUCT_BASE_PATHS.dbo}/${DboRoute.DB_ROOT}/*`;

export const emptyDboParams: DboSidebarParams = {
  dbServerId: undefined,
  databaseId: undefined,
};

export const resolveDboSidebarParams = (
  stored: DboSidebarParams,
  urlParams: DboSidebarParams
): DboSidebarParams => {
  const effectiveDbServerId = urlParams.dbServerId ?? stored.dbServerId;
  const storedDatabaseId =
    stored.dbServerId === effectiveDbServerId ? stored.databaseId : undefined;
  const effectiveDatabaseId = urlParams.databaseId ?? storedDatabaseId;

  return {
    dbServerId: effectiveDbServerId,
    databaseId: effectiveDatabaseId,
  };
};
